import React, { useEffect, useRef, useState } from "react";

export default function AutoVideo({ src, poster, className }) {
  const ref = useRef(null);
  const [videoSrc, setVideoSrc] = useState(null);

  // Defer video loading until the page has painted (hero wheel/logo load first)
  useEffect(() => {
    let timer;
    const start = () => { timer = setTimeout(() => setVideoSrc(src), 200); };
    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });
    return () => { clearTimeout(timer); window.removeEventListener("load", start); };
  }, [src]);

  useEffect(() => {
    const v = ref.current;
    if (!v || !videoSrc) return;
    v.muted = true;
    v.defaultMuted = true;
    const play = () => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    play();
    v.addEventListener("canplay", play, { once: true });
    v.addEventListener("loadeddata", play, { once: true });
    return () => {
      v.removeEventListener("canplay", play);
      v.removeEventListener("loadeddata", play);
    };
  }, [videoSrc]);

  return (
    <video ref={ref} src={videoSrc || undefined} poster={poster} autoPlay muted loop playsInline
      preload="none" fetchPriority="low" className={className} />
  );
}
